const preservedAcronyms = new Set(['DVT', 'OTS', 'PVT', 'WQN']);
const displayLabelCollator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: 'base',
});

export function humanizeIdentifier(value: string): string {
  const label = value
    .split('_')
    .filter(Boolean)
    .map((part) => {
      if (preservedAcronyms.has(part)) return part;
      const measurement = part.match(/^(\d+)(M)$/);
      if (measurement) return `${measurement[1]} m`;
      return part.toLowerCase();
    })
    .join(' ');

  return label.charAt(0).toUpperCase() + label.slice(1);
}

export function compareDisplayLabels(left: string, right: string): number {
  return displayLabelCollator.compare(left, right);
}

export function sortByDisplayLabel<T>(values: readonly T[], getLabel: (value: T) => string): T[] {
  return [...values].sort((left, right) => compareDisplayLabels(getLabel(left), getLabel(right)));
}
